var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_726",
    "data-name": "Group 726",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.905,
    height: 19.628,
    viewBox: "0 0 19.905 19.628",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 19.905,
    height: 19.628,
    fill: "#313131"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M12.656,14.628a7.976,7.976,0,0,1-2.045,1.031,7.909,7.909,0,0,1-5.9-.308,7.906,7.906,0,0,1-3.7-3.423A7.853,7.853,0,0,1,.022,7.462a7.891,7.891,0,0,1,1.3-3.835A7.944,7.944,0,0,1,4.211.971,7.879,7.879,0,0,1,8.281,0a7.846,7.846,0,0,1,4.594,1.617A7.817,7.817,0,0,1,15.84,6.076a7.851,7.851,0,0,1-.856,6.013.272.272,0,0,0,.049.4Q17.2,14.64,19.353,16.8a1.608,1.608,0,0,1-2.044,2.482c-.1-.082-.2-.169-.288-.26q-2.112-2.109-4.22-4.22c-.05-.05-.09-.11-.144-.177m.826-6.6a5.438,5.438,0,1,0-5.417,5.441,5.449,5.449,0,0,0,5.417-5.441",
    transform: "translate(0 0)",
    fill: "#313131"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlack);
export default __webpack_public_path__ + "static/media/search-black.83cb0e163e69994ac13d342c5789e914.svg";
export { ForwardRef as ReactComponent };